// extracted by mini-css-extract-plugin
export default {"wrapper":"Zoomer__wrapper--DO3X5","value":"Zoomer__value--1Pl5b","button":"Zoomer__button--3SDV2"};